module.exports = __webpack_public_path__ + "static/media/timeline-copy-5.b0bfab40.png";